import React from 'react';

import wrapper from '../../redux';

import FreeQuizContainer from '../../container/FreeQuiz';

const index = () => <FreeQuizContainer />;

export const getServerSideProps = wrapper.getServerSideProps(() => async () => ({
  props: {
    footer: { hide: true },
  },
}));

export default index;
